export const TafMark = ({ size = 40, className = "" }) => (
  <img
    src="/brand/taf-icon.png"
    alt="TAF Beach Villas"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    data-testid="taf-mark"
  />
);

export const TafLogo = ({ height = 44, light = false, className = "" }) => (
  <img
    src={light ? "/brand/taf-logo-white.png" : "/brand/taf-logo.png"}
    alt="TAF Beach Villas"
    style={{ height }}
    className={`w-auto object-contain ${className}`}
    data-testid="taf-logo"
  />
);

export const TafLockup = ({ subtitle = "Kos Island · Operations", light = true }) => (
  <div className="flex flex-col gap-1.5" data-testid="taf-lockup">
    <TafLogo height={40} light={light} />
    <span className={`font-mono text-[9px] uppercase tracking-[0.2em] ${light ? "text-white/60" : "text-[#8A8577]"}`}>
      {subtitle}
    </span>
  </div>
);
